module.exports = __webpack_public_path__ + "static/media/print5.37e3ddd2.jpg";